const form = document.getElementById('form_group_submission');
const closeButton = document.getElementById('close_group_modal');
const openButton = document.getElementById('show_group_modal');

const showModal = () => {
  if(form){
    form.style.display = 'block';
  }
}

const closeModal = () => {
  if(form){
    form.style.display = 'none';
  }
}

if (form && openButton && closeButton) {
  openButton.addEventListener('click', showModal);
  closeButton.addEventListener('click', closeModal);
  form.addEventListener('submit', closeModal);
}
